import React from "react";
const RatingFeedback = () => {
  return <div style={{ padding: "20px" }}>⭐ Rating & Feedback content goes here.</div>;
};
export default RatingFeedback;
